import React from "react"

import * as THREE 					from "three";
import { FBXLoader } 				from 'three/examples/jsm/loaders/FBXLoader.js';
import { ColladaLoader } 				from 'three/examples/jsm/loaders/ColladaLoader.js';
import { GLTFLoader } 				from 'three/examples/jsm/loaders/GLTFLoader.js';
import { Reflector } 				from 'three/examples/jsm/objects/Reflector.js';
import { TweenMax,TimelineMax, Back, Quart, Sine, Bounce } 	from 'gsap';
import { withPrefix } 				from "gatsby";
import { WaterfallShader, PlantsShader, FishShader, ParticlesShader } 			from "./shaders";

import imgCircle 					from "./assets/3d/tex_intro/circle.png";
import imgMountains 				from "./assets/3d/tex_intro/mountains.png";
import imgTreeFront 				from "./assets/3d/tex_intro/tree_front.png";
import imgTreeBack 					from "./assets/3d/tex_intro/tree_back.png";
import imgReflections 				from "./assets/3d/tex/reflections.png";
import imgTurtleAlbedo 				from "./assets/3d/tex/turtle_albedo.png";
import imgTurtleAO 					from "./assets/3d/tex/turtle_ao.png";
import imgTreeBranchesAlbedo 		from "./assets/3d/tex/tree_branches_albedo.png";
import imgTreeLeafsAlbedo 			from "./assets/3d/tex/tree_leafs_albedo.png";
import imgTreeLeafsAO 				from "./assets/3d/tex/tree_leafs_ao.png";
import imgSnakeTreeLeafsAlbedo 		from "./assets/3d/tex/snake_tree_leafs_albedo.png";
import imgSnakeTreeLeafsAO 			from "./assets/3d/tex/snake_tree_leafs_ao.jpg";
import imgSnakeTreeBranchesAlbedo 	from "./assets/3d/tex/snake_tree_branches_albedo.png";
import imgSnakeTreeBranchesAO 		from "./assets/3d/tex/snake_tree_branches_ao.jpg";
import imgSnakeAlbedo 				from "./assets/3d/tex/snake_albedo.png";
import imgSnakeAO 					from "./assets/3d/tex/snake_ao.png";
import imgPalmLeaf 					from "./assets/3d/tex/palm_leaf.png";
import imgHillFrontRightAlbedo 		from "./assets/3d/tex/hill_front_right_albedo.png";
import imgHillBackRightAlbedo 		from "./assets/3d/tex/hill_back_right_albedo.png";
import imgCliffFrontAlbedo 			from "./assets/3d/tex/cliff_front_albedo.png";
import imgCliffBackAlbedo 			from "./assets/3d/tex/cliff_back_albedo.png";
import imgMoutain1 					from "./assets/3d/tex/Mountain1.png";
import imgMoutain2 					from "./assets/3d/tex/Mountain2.png";
import imgMoutain3 					from "./assets/3d/tex/Mountain3.png";
import imgMoutain4 					from "./assets/3d/tex/Mountain4.png";
import imgMoutain5 					from "./assets/3d/tex/Mountain5.png";
import imgSceneBG 					from "./assets/3d/tex/scene_bg.jpg";
import imgBush1 					from "./assets/3d/tex/bush1.png";
import imgBush2 					from "./assets/3d/tex/bush2.png";
import imgToucan 					from "./assets/3d/tex/toucan.png";
import imgHoleFront 				from "./assets/3d/tex/hole_front.png";
import imgHoleBack 					from "./assets/3d/tex/hole_back.png";
import imgNoise 					from "./assets/3d/tex/noise.png";
import imgTailsLeft 				from "./assets/3d/tex/tails_left.png";
import imgTailsRight 				from "./assets/3d/tex/tails_right.png";
import imgFish		 				from "./assets/3d/tex/fish.png";
import imgBubble		 			from "./assets/3d/tex/bubble.png";
import imgRoundBGreen		 		from "./assets/3d/tex/roundb_green.png";
import imgRoundBRed		 			from "./assets/3d/tex/roundb_red.png";
import imgParticle		 			from "./assets/3d/tex/particle.png";

class ThreeWorld extends React.Component {
	componentDidMount() {
		var that = this;

		this.canvasHeight = 1100;

		this.elements = [];

		this.mX = 0;
		this.mY = 0;

		this.sceneIntro = new THREE.Scene();
		this.scene = new THREE.Scene();
		this.camera = new THREE.PerspectiveCamera(30,window.innerWidth/window.innerHeight,2000,40000);

		this.camera.position.z = 5500;
		this.camera.position.y = 1000;

		this.camTarget = new THREE.Vector3(0,700,-500);
		this.camera.lookAt(this.camTarget);

		this.renderer = new THREE.WebGLRenderer({antialias:true});
		this.renderer.setSize(window.innerWidth,window.innerHeight);
		this.renderer.setClearColor(0x52BBEA,1);
		var pr = window.devicePixelRatio*0.65;
		if(pr < 1){
			pr = 1;
		}
		this.renderer.setPixelRatio(pr);

		this.rendererIntro = new THREE.WebGLRenderer({antialias:false});
		this.rendererIntro.setSize(window.innerWidth,window.innerHeight);
		this.rendererIntro.setClearColor(0xE0D6B0,1);
		var prIntro = window.devicePixelRatio*0.85;
		if(prIntro < 1){
			prIntro = 1;
		}
		this.rendererIntro.setPixelRatio(prIntro);

		this.threeEl.appendChild(this.renderer.domElement);
		this.threeEl.appendChild(this.rendererIntro.domElement);
		this.threeGradient = document.createElement("div");
		this.threeGradient.classList.add("gradient");
		this.threeEl.appendChild(this.threeGradient);


		/* INTRO SCENE */
		this.introGroundMat = new THREE.MeshBasicMaterial({
			color:0xE0D6B0
		});

		this.introCircleMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgCircle),
			transparent:true
		});

		this.introCircleMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.introCircleMat.map.minFilter = THREE.LinearFilter;

		this.introMountainsMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgMountains),
			transparent:true
		});

		this.introMountainsMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.introMountainsMat.map.minFilter = THREE.LinearFilter;

		this.introTreeFrontMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgTreeFront),
			transparent:true
		});

		this.introTreeFrontMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.introTreeFrontMat.map.minFilter = THREE.LinearFilter;

		this.introTreeBackMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgTreeBack),
			transparent:true
		});

		this.introTreeBackMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.introTreeBackMat.map.minFilter = THREE.LinearFilter;

		this.loaderIntro = new FBXLoader();
		this.loaderIntro.load(withPrefix("/assets/3d/intro_low.fbx"),function(fbx){
			that.fbxIntro = fbx;

			fbx.traverse(function(obj){
				if(obj.material != null){
					switch(obj.material.name){
						case 'ground':
							obj.material = that.introGroundMat;
						break;
						case 'circle':
							obj.material = that.introCircleMat;
							that.circle = obj;
							that.circle.orX = obj.position.x;
						break;
						case 'mountains':
							obj.material = that.introMountainsMat;
						break;
						case 'tree_front':
							obj.material = that.introTreeFrontMat;
						break;
						case 'tree_back':
							obj.material = that.introTreeBackMat;
							that.treeBack = obj;
							that.treeBack.orX = obj.position.x;
						break;
					}
				}
			});

			that.sceneIntro.add(fbx);
		});


		/* MAIN SCENE */
		this.bg = new THREE.Mesh(new THREE.PlaneBufferGeometry(22000*1.3,13000*1.3,1,1),new THREE.MeshBasicMaterial({color:0xffffff,map:new THREE.TextureLoader().load(imgSceneBG)}));
		this.bg.position.z = -30000;
		this.bg.position.y = 500;
		this.scene.add(this.bg);

		this.waterMat = new THREE.MeshBasicMaterial({
			color:0x52BBEA
		});

		this.waterReflectionsMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgReflections),
			transparent:true,
			depthWrite:false
		});

		this.turtleMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgTurtleAlbedo),
			// aoMap:new THREE.TextureLoader().load(imgTurtleAO),
			// aoMapIntensity:0.3,
			morphTargets:true,
			transparent:true,
			side:THREE.DoubleSide
		});

		this.turtleMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.turtleMat.map.minFilter = THREE.LinearFilter;
		// this.turtleMat.aoMap.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		// this.turtleMat.aoMap.minFilter = THREE.LinearFilter;

		this.treeBranchesMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgTreeBranchesAlbedo),
			transparent:true,
			side:THREE.DoubleSide,
			depthWrite:false
		});

		this.treeLeafsMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgTreeLeafsAlbedo),
			aoMap:new THREE.TextureLoader().load(imgTreeLeafsAO),
			aoMapIntensity:0.2,
			transparent:true,
			side:THREE.DoubleSide
		});

		this.treeLeafsMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.treeLeafsMat.map.minFilter = THREE.LinearFilter;
		this.treeLeafsMat.aoMap.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.treeLeafsMat.aoMap.minFilter = THREE.LinearFilter;

		this.snakeTreeLeafsMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgSnakeTreeLeafsAlbedo),
			aoMap:new THREE.TextureLoader().load(imgSnakeTreeLeafsAO),
			aoMapIntensity:0.5,
			side:THREE.DoubleSide
		});

		this.snakeTreeLeafsMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.snakeTreeLeafsMat.map.minFilter = THREE.LinearFilter;
		this.snakeTreeLeafsMat.aoMap.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.snakeTreeLeafsMat.aoMap.minFilter = THREE.LinearFilter;

		this.snakeTreeBranchesMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			side:THREE.DoubleSide,
			map:new THREE.TextureLoader().load(imgSnakeTreeBranchesAlbedo),
			aoMap:new THREE.TextureLoader().load(imgSnakeTreeBranchesAO),
			aoMapIntensity:0.5
		});

		this.snakeTreeBranchesMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.snakeTreeBranchesMat.map.minFilter = THREE.LinearFilter;
		this.snakeTreeBranchesMat.aoMap.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.snakeTreeBranchesMat.aoMap.minFilter = THREE.LinearFilter;

		this.snakeBodyMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgSnakeAlbedo),
			// aoMap:new THREE.TextureLoader().load(imgSnakeAO),
			// aoMapIntensity:0.5,
			// side:THREE.DoubleSide,
			morphTargets: true
		});

		this.snakeBodyMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.snakeBodyMat.map.minFilter = THREE.LinearFilter;
		// this.snakeBodyMat.aoMap.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		// this.snakeBodyMat.aoMap.minFilter = THREE.LinearFilter;

		this.snakeTongueMat = new THREE.MeshBasicMaterial({
			color:0x000000,
			side:THREE.DoubleSide,
			morphTargets: true
		});

		this.palmTreeLeafsMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgPalmLeaf),
			transparent:true,
			side:THREE.DoubleSide,
			depthWrite:true,
			alphaTest:0.5
		});

		this.palmTreeTrunkMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:this.snakeTreeBranchesMat.map,
			side:THREE.DoubleSide
		});

		this.hillFrontRightMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgHillFrontRightAlbedo),
			transparent:true,
			side:THREE.DoubleSide
		});

		this.hillBackRightMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgHillBackRightAlbedo),
			transparent:true,
			side:THREE.DoubleSide
		});

		this.cliffFrontMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgCliffFrontAlbedo),
			transparent:true,
			side:THREE.DoubleSide
		});

		this.cliffBackMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgCliffBackAlbedo),
			transparent:true,
			side:THREE.DoubleSide
		});

		this.bubbleMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgBubble),
			transparent:true,
			side:THREE.DoubleSide,
			depthWrite:true,
			alphaTest:0.5
		});


		this.bubbleMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.bubbleMat.map.minFilter = THREE.LinearFilter;

		this.roundBGreenMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgRoundBGreen),
			transparent:true,
			depthWrite:true,
			alphaTest:0.5
		});

		this.roundBGreenMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.roundBGreenMat.map.minFilter = THREE.LinearFilter;

		this.roundBRedMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgRoundBRed),
			transparent:true,
			depthWrite:true,
			alphaTest:0.5
		});

		this.roundBRedMat.map.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.roundBRedMat.map.minFilter = THREE.LinearFilter;

		this.bush1Mat = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:1},
				map:{value:new THREE.TextureLoader().load(imgBush1)}
			},
			fragmentShader:PlantsShader.fragmentShader,
			vertexShader:PlantsShader.vertexShader,
			transparent:true,
			alphaTest:0.5,
			side:THREE.DoubleSide
		});

		this.bush1Mat.uniforms["map"].value.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.bush1Mat.uniforms["map"].value.minFilter = THREE.LinearFilter;

		this.bush2Mat = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:25},
				map:{value:new THREE.TextureLoader().load(imgBush2)}
			},
			fragmentShader:PlantsShader.fragmentShader,
			vertexShader:PlantsShader.vertexShader,
			transparent:true,
			alphaTest:0.5,
			side:THREE.DoubleSide
		});
		this.bush2Mat.uniforms["map"].value.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.bush2Mat.uniforms["map"].value.minFilter = THREE.LinearFilter;


		this.tailsLeftMat = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:74},
				map:{value:new THREE.TextureLoader().load(imgTailsLeft)}
			},
			fragmentShader:PlantsShader.fragmentShader,
			vertexShader:PlantsShader.vertexShader,
			transparent:true,
			depthWrite:false,
			alphaTest:0.5,
			side:THREE.DoubleSide
		});

		this.tailsLeftMat.uniforms["map"].value.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.tailsLeftMat.uniforms["map"].value.minFilter = THREE.LinearFilter;


		this.tailsRightMat = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:52},
				map:{value:new THREE.TextureLoader().load(imgTailsRight)}
			},
			fragmentShader:PlantsShader.fragmentShader,
			vertexShader:PlantsShader.vertexShader,
			transparent:true,
			alphaTest:0.5,
			side:THREE.DoubleSide
		});

		this.tailsRightMat.uniforms["map"].value.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.tailsRightMat.uniforms["map"].value.minFilter = THREE.LinearFilter;


		this.fishMat = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:52},
				map:{value:new THREE.TextureLoader().load(imgFish)}
			},
			fragmentShader:FishShader.fragmentShader,
			vertexShader:FishShader.vertexShader,
			transparent:true,
			depthWrite:false,
			depthTest:false,
			side:THREE.DoubleSide
		});

		this.fishMat.uniforms["map"].value.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.fishMat.uniforms["map"].value.minFilter = THREE.LinearFilter;

		this.fish2Mat = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:52},
				map:{value:new THREE.TextureLoader().load(imgFish)}
			},
			fragmentShader:FishShader.fragmentShader,
			vertexShader:FishShader.vertexShader,
			transparent:true,
			depthWrite:false,
			depthTest:false,
			side:THREE.DoubleSide
		});

		this.fish2Mat.uniforms["map"].value.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.fish2Mat.uniforms["map"].value.minFilter = THREE.LinearFilter;


		this.toucanMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgToucan),
			transparent:true,
			side:THREE.DoubleSide
		});

		this.waterfallBackMat = new THREE.MeshBasicMaterial({
			color:0x003F75,
			side:THREE.DoubleSide
		});

		this.waterfallMat = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:1},
				color1:{value:new THREE.Color(0x52BBEA)},
				color2:{value:new THREE.Color(0xffffff)},
				color3:{value:new THREE.Color(0xFFEC81)},
				noiseMap:{value:new THREE.TextureLoader().load(imgNoise)}
			},
			fragmentShader:WaterfallShader.fragmentShader,
			vertexShader:WaterfallShader.vertexShader
		});

		this.waterfallMat.uniforms['noiseMap'].value.wrapS = THREE.RepeatWrapping;
		this.waterfallMat.uniforms['noiseMap'].value.wrapT = THREE.RepeatWrapping;

		this.holeFrontMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgHoleFront),
			transparent:true,
			side:THREE.DoubleSide,
			depthWrite:true,
			alphaTest:0.5
		});

		this.holeBackMat = new THREE.MeshBasicMaterial({
			color:0xffffff,
			map:new THREE.TextureLoader().load(imgHoleBack),
			transparent:true,
			side:THREE.DoubleSide,
			depthWrite:true,
			alphaTest:0.5
		});

		var particlesUniforms = {
			pointTexture: { value: new THREE.TextureLoader().load( imgParticle ) },
			time:{value:0},
			move:{value:0},
			mainOpacity:{value:0}
		};
		
		this.particlesMat = new THREE.ShaderMaterial( {
			uniforms: particlesUniforms,
			vertexShader: ParticlesShader.vertexShader,
			fragmentShader: ParticlesShader.fragmentShader,
			transparent: true,
			depthWrite:false,
			depthTest:false,
			vertexColors: true
		} );

		this.particlesMat.uniforms["pointTexture"].value.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
		this.particlesMat.uniforms["pointTexture"].value.minFilter = THREE.LinearFilter;

		this.bubbles = [];
		this.palmLeafs = [];

		this.loader = new FBXLoader();
		this.loader.load(withPrefix("/assets/3d/scene_low.fbx"),function(fbx){

			that.fbx = fbx;

			fbx.scale.set(1,1,1);

			var snakeGeoCount = 0;
			var snakeTGeoCount = 0;

			fbx.traverse(function(obj){

				switch(obj.name){
					case "turtle":
						that.turtle = obj;
						that.turtleOrY = obj.position.y;
						that.turtle.orX = obj.position.x;
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.52;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "turtle_legs":
						that.turtleLegs = obj;
					break;
					case "snake":
						that.snake = obj;
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.9;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "toucan":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.325;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "toucan2":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.2;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "snake_tree":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.5;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "palmtree":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.6;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "hill_front_right":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.1;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "cliff_front":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.15;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "hill_back_right":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.2;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "cliff_back":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.25;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "waterfall":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.75;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "bubbles_front":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.75;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "waterfall2":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.8;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "bubbles_back":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.8;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "tree":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.3;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "roundb_front":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.275;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "roundb_back":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.455;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "bush1":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.25;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "tree_1":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.35;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "bush2":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.375;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "tree_2":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.4;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "Mountain4":
						obj.scale.set(1,0.0001,0.0001);
						obj.threshold = 0.05;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "bush3":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.15;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "fish":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.275;
						obj.isShown = false;
						that.fish = obj;
						that.fish.offset = 0;
						obj.renderOrder = 11;
						that.elements.push(obj);
					break;
					case "fish2":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.275;
						obj.isShown = false;
						that.fish2 = obj;
						that.fish2.offset = Math.PI;
						obj.renderOrder = 12;
						that.elements.push(obj);
					break;

					case "tails_right":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.375;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "tails_left":
						obj.scale.set(0.0001,0.0001,0.0001);
						obj.threshold = 0.25;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "Mountain3":
						obj.scale.set(1,0.0001,0.0001);
						obj.threshold = 0.075;
						obj.isShown = false;
						that.elements.push(obj);
					break;

					case "Mountain2":
						obj.scale.set(1,0.0001,0.0001);
						obj.threshold = 0.125;
						obj.isShown = false;
						that.elements.push(obj);
					break;
					case "Mountain1":
						obj.scale.set(1,0.0001,0.0001);
						obj.threshold = 0.215;
						obj.isShown = false;
						that.elements.push(obj);
					break;
				}

				if(obj.name.indexOf("bubble") != -1 && obj.type == "Mesh"){
					obj.material = that.bubbleMat;
					that.bubbles.push(obj);
					obj.currScale = Math.random()+0.0001;
					obj.speed = 0.02 + (Math.random()-0.5)*0.02;
					obj.scale.set(obj.currScale,obj.currScale,obj.currScale);

				}

				if(obj.name == "particlesLeft"){
					that.partProxyLeft = obj;
					var geo = new THREE.Geometry().fromBufferGeometry(obj.geometry);
					var colors = [];
					var sizes = [];
					geo.vertices.forEach(function(v){
						sizes.push( (Math.random()*80+5) );
					});
					obj.geometry.setAttribute( 'size', new THREE.Float32BufferAttribute( sizes, 1 ));
					that.particlesLeft = new THREE.Points(obj.geometry,that.particlesMat);
					that.particlesLeft.position.x = obj.position.x;
					that.particlesLeft.position.y = obj.position.y;
					that.particlesLeft.position.z = obj.position.z;
					that.particlesLeft.renderOrder = 100;
				}

				if(obj.name == "particlesRight"){
					that.partProxyRight = obj;
					var geo = new THREE.Geometry().fromBufferGeometry(obj.geometry);
					var colors = [];
					var sizes = [];
					geo.vertices.forEach(function(v){
						sizes.push( Math.random()*80+5 );
					});
					obj.geometry.setAttribute( 'size', new THREE.Float32BufferAttribute( sizes, 1 ));
					that.particlesRight = new THREE.Points(obj.geometry,that.particlesMat);
					that.particlesRight.position.x = obj.position.x;
					that.particlesRight.position.y = obj.position.y;
					that.particlesRight.position.z = obj.position.z;
					that.particlesRight.renderOrder = 100;
				}

				if(obj.name == "toucan"){
					that.toucan = obj;
					that.toucan.offset = 0;
					that.toucan.orZ = obj.position.z;
					that.toucan.orY = obj.position.y;
				}

				if(obj.name == "toucan2"){
					that.toucan2 = obj;
					that.toucan2.offset = Math.PI;
					that.toucan2.orZ = obj.position.z;
					that.toucan2.orY = obj.position.y;
				}

				if(obj.name == "snake_tree"){
					that.snakeTree = obj;
				}

				if(obj.name == "container_snake_tree"){
					that.containerSnakeTree = obj;
					that.containerSnakeTree.orX = obj.position.x;
					that.containerSnakeTree.orY = obj.position.y;
				}
				
				if(obj.name == "container_left"){
					that.containerLeft = obj;
				}

				if(obj.name == "container_left_front"){
					that.containerLeftFront = obj;
				}

				if(obj.name == "container_left_back"){
					that.containerLeftBack = obj;
				}

				if(obj.name == "container_right"){
					that.containerRight = obj;
				}

				if(obj.name == "container_palmtree"){
					that.containerPalmTree = obj;
					that.containerPalmTree.orX = obj.position.x;
					that.containerPalmTree.orY = obj.position.y;
				}

				if(obj.material != null){

					if(obj.material.name == "Mountain1"){
						obj.material = new THREE.MeshBasicMaterial({
							map:new THREE.TextureLoader().load(imgMoutain1),
							transparent:true,
							side:THREE.DoubleSide,
							depthWrite:false
						});
					}
					else if(obj.material.name == "Mountain2"){
						obj.material = new THREE.MeshBasicMaterial({
							map:new THREE.TextureLoader().load(imgMoutain2),
							transparent:true,
							side:THREE.DoubleSide,
							depthWrite:false
						});
					}
					else if(obj.material.name == "Mountain3"){
						obj.material = new THREE.MeshBasicMaterial({
							map:new THREE.TextureLoader().load(imgMoutain3),
							transparent:true,
							side:THREE.DoubleSide,
							depthWrite:false
						});
					}
					else if(obj.material.name == "Mountain4"){
						obj.material = new THREE.MeshBasicMaterial({
							map:new THREE.TextureLoader().load(imgMoutain4),
							transparent:true,
							side:THREE.DoubleSide,
							depthWrite:false
						});
					}
					else if(obj.material.name == "Mountain5"){
						obj.material = new THREE.MeshBasicMaterial({
							map:new THREE.TextureLoader().load(imgMoutain5),
							transparent:true,
							side:THREE.DoubleSide,
							depthWrite:false
						});
					}
					else{
						switch(obj.material.name){
							case "water":
								obj.material = that.waterMat;
								that.water = obj;

								that.reflector = new Reflector(new THREE.PlaneBufferGeometry(7500,7500,1,1),{
									textureWidth: window.innerWidth*0.25,
									textureHeight: window.innerHeight*0.25,
									color: 0x52BBEA
								});
								that.reflector.position.x = obj.position.x;
								that.reflector.position.y = obj.position.y+1;
								that.reflector.position.z = obj.position.z;
								that.reflector.rotation.x = -Math.PI/2;

								that.fbx.add(that.reflector);
							break;
							case "turtle":
								if(obj.name.indexOf("turtle_head") != -1){
									var geo = new THREE.Geometry().fromBufferGeometry(obj.geometry);
									if(!that.turtleGeo){
										that.turtleGeo = geo;
										that.turtleHeadOr = obj;
									}
									else{
										that.turtleGeo.morphTargets.push( { name: "target" + Math.random(), vertices: geo.vertices } );
										
									}
									obj.visible = false;
								}
								else{
									obj.material = that.turtleMat;
								}
								
							break;
							case "snake_body":
								if(obj.name.indexOf("snake_body") != -1){
									var geo = new THREE.Geometry().fromBufferGeometry(obj.geometry);
									if(!that.snakeGeo){
										that.snakeGeo = geo;
									}
									else{
										that.snakeGeo.morphTargets.push( { name: "target" + snakeGeoCount, vertices: geo.vertices } );
										snakeGeoCount++;
									}
									obj.visible = false;
								}
								else{
									obj.material = that.snakeBodyMat;
								}
							break;
							case "snake_tongue":
								var geo = new THREE.Geometry().fromBufferGeometry(obj.geometry);
								if(!that.snakeTGeo){
									that.snakeTGeo = geo;
									that.snakeTOr = obj;
								}
								else{
									that.snakeTGeo.morphTargets.push( { name: "target" + snakeTGeoCount, vertices: geo.vertices } );
									snakeTGeoCount++;
								}
								obj.visible = false;
							break;
							case "hill_back_right":
								obj.material = that.hillBackRightMat;
							break;
							case "reflections":
								obj.material = that.waterReflectionsMat;
							break;
							case "hill_front_right":
								obj.material = that.hillFrontRightMat;
							break;
							case "cliff_front":
								obj.material = that.cliffFrontMat;
							break;
							case "cliff_back":
								obj.material = that.cliffBackMat;
							break;
							case "palmtree_leaf":
								obj.material = that.palmTreeLeafsMat;
								that.palmLeafs.push(obj);
								obj.offset = Math.random()*5+5;
								obj.speed = Math.random()*2+2;
							break;
							case "palmtree_trunk":
								obj.material = that.palmTreeTrunkMat;
							break;
							case "bush1":
								obj.material = that.bush1Mat;
							break;
							case "bush2":
								obj.material = that.bush2Mat;
							break;
							case "roundb_green":
								obj.material = that.roundBGreenMat;
							break;
							case "roundb_red":
								obj.material = that.roundBRedMat;
							break;
							case "bush2":
								obj.material = that.bush2Mat;
							break;
							case "tails_left":
								obj.material = that.tailsLeftMat;
								obj.renderOrder = 10;
							break;
							case "tails_right":
								obj.material = that.tailsRightMat;
							break;
							case "fish":
								obj.material = that.fishMat;
								// obj.renderOrder = 10+Math.random();
							break;
							case "fish2":
								obj.material = that.fish2Mat;
								// obj.renderOrder = 10+Math.random();
							break;
							case "toucan":
								obj.material = that.toucanMat;
							break;
							case "waterfall":
								obj.material = that.waterfallMat;
							break;
							case "waterfallBack":
								obj.material = that.waterfallBackMat;
							break;
							case "hole_front":
								obj.material = that.holeFrontMat;
							break;
							case "hole_back":
								obj.material = that.holeBackMat;
							break;
							case "tree_leafs":
								obj.material = that.treeLeafsMat;
								var geometry = obj.geometry;
								var uvs = geometry.attributes.uv.array;
								geometry.setAttribute( 'uv2', new THREE.BufferAttribute( uvs, 2 ) );
							break;
							case "tree_branches":
								obj.material = that.treeBranchesMat;
								var geometry = obj.geometry;
								var uvs = geometry.attributes.uv.array;
								geometry.setAttribute( 'uv2', new THREE.BufferAttribute( uvs, 2 ) );
							break;
							case "snake_tree_leafs":
								obj.material = that.snakeTreeLeafsMat;
								var geometry = obj.geometry;
								var uvs = geometry.attributes.uv.array;
								geometry.setAttribute( 'uv2', new THREE.BufferAttribute( uvs, 2 ) );
							break;
							case "snake_tree_branches":
								obj.material = that.snakeTreeBranchesMat;
								var geometry = obj.geometry;
								var uvs = geometry.attributes.uv.array;
								geometry.setAttribute( 'uv2', new THREE.BufferAttribute( uvs, 2 ) );
							break;
						}
					}
				}
				that.clock.start();
			});

			that.containerLeftFront.add(that.particlesLeft);
			that.containerRight.add(that.particlesRight);
			that.containerLeftFront.remove(that.partProxyLeft);
			that.containerRight.remove(that.partProxyRight);
			that.scene.add(fbx);

			that.snakeBody = new THREE.Mesh( new THREE.BufferGeometry().fromGeometry(that.snakeGeo),that.snakeBodyMat);
			that.snake.add(that.snakeBody);

			that.snakeT = new THREE.Mesh( new THREE.BufferGeometry().fromGeometry(that.snakeTGeo),that.snakeTongueMat);
			that.snake.add(that.snakeT);
			that.snakeT.scale.set(0.001,0.001,0.001);
			that.snakeT.position.x = that.snakeTOr.position.x;
			that.snakeT.position.y = that.snakeTOr.position.y;
			that.snakeT.position.z = that.snakeTOr.position.z;

			that.snakeMorphValues = [];
			that.snakeBody.morphTargetInfluences.forEach(function(){
				that.snakeMorphValues.push({value:0});
			});

			that.snakeTimeline = new TimelineMax({repeat:-1,onUpdate:function(){
				that.snakeBody.morphTargetInfluences.forEach(function(val,i){
					that.snakeBody.morphTargetInfluences[i] = that.snakeMorphValues[i].value;
					that.snakeT.morphTargetInfluences[i] = that.snakeMorphValues[i].value;
				});
			}});
			that.snakeTimeline.timeScale(0.2);
			that.snakeTimeline.to(that.snakeT.scale,0.02,{x:1,y:1,z:1,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeT.scale,0.02,{x:0.3,y:0.3,z:0.3,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeT.scale,0.02,{x:1,y:1,z:1,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeT.scale,0.02,{x:0.001,y:0.001,z:0.001,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeMorphValues[0],0.5,{value:0,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeMorphValues[1],0.5,{value:1,ease:Sine.easeInOut},"-=0.5");
			that.snakeTimeline.to(that.snakeMorphValues[1],0.5,{value:0,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeMorphValues[2],0.5,{value:1,ease:Sine.easeInOut},"-=0.5");
			that.snakeTimeline.to(that.snakeT.scale,0.02,{x:1,y:1,z:1,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeT.scale,0.02,{x:0.001,y:0.001,z:0.001,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeMorphValues[2],0.5,{value:0,ease:Sine.easeInOut});
			that.snakeTimeline.to(that.snakeMorphValues[3],0.5,{value:1,ease:Sine.easeInOut},"-=0.5");
			that.snakeTimeline.to(that.snakeMorphValues[3],0.5,{value:0,ease:Sine.easeInOut});
			that.snakeTimeline.play();

			that.turtleHead = new THREE.Mesh( new THREE.BufferGeometry().fromGeometry(that.turtleGeo),that.turtleMat);
			that.turtle.add(that.turtleHead);
			that.turtleHead.position.x = that.turtleHeadOr.position.x;
			that.turtleHead.position.y = that.turtleHeadOr.position.y;
			that.turtleHead.position.z = that.turtleHeadOr.position.z;

			that.turtleMorphValues = [];
			that.turtleHead.morphTargetInfluences.forEach(function(){
				that.turtleMorphValues.push({value:0});
			});

			that.turtleTimeline = new TimelineMax({repeat:-1,onUpdate:function(){
				that.turtleHead.morphTargetInfluences.forEach(function(val,i){
					that.turtleHead.morphTargetInfluences[i] = that.turtleMorphValues[i].value;
				});
			}});
			that.turtleTimeline.timeScale(0.2);
			that.turtleTimeline.to(that.turtleMorphValues[0],0.5,{value:0,ease:Quart.easeInOut});
			that.turtleTimeline.to(that.turtleMorphValues[1],0.5,{value:1,ease:Quart.easeInOut},"-=0.5");
			that.turtleTimeline.to(that.turtleMorphValues[1],0.5,{value:0,ease:Quart.easeInOut});
			that.turtleTimeline.to(that.turtleMorphValues[2],0.5,{value:1,ease:Quart.easeInOut},"-=0.5");
			that.turtleTimeline.to(that.turtleMorphValues[2],0.5,{value:0,ease:Quart.easeInOut});
			that.turtleTimeline.to(that.turtleMorphValues[3],0.5,{value:1,ease:Quart.easeInOut},"-=0.5");
			that.turtleTimeline.to(that.turtleMorphValues[3],0.5,{value:0,ease:Quart.easeInOut});
			that.turtleTimeline.to(that.turtleHead.scale,0.05,{x:0.001,y:0.001,z:0.001,ease:Quart.easeIn});
			that.turtleTimeline.to(that.turtleLegs.scale,0.05,{x:0.001,y:0.001,z:0.001,ease:Quart.easeIn},"-=0.05");
			that.turtleTimeline.to(that.turtle.position,0.15,{y:that.turtleOrY-30,ease:Bounce.easeOut},"-=0.05");
			that.turtleTimeline.to(that.turtle.rotation,0.15,{x:0.1,ease:Bounce.easeInOut},"-=0.15");
			that.turtleTimeline.to(that.turtleHead.scale,0.08,{x:1,y:1,z:1,ease:Quart.easeOut},"+=0.5");
			that.turtleTimeline.to(that.turtleLegs.scale,0.08,{x:1,y:1,z:1,ease:Quart.easeOut},"-=0.08");
			that.turtleTimeline.to(that.turtle.position,0.1,{y:that.turtleOrY,ease:Back.easeOut},"-=0.08");
			that.turtleTimeline.to(that.turtle.rotation,0.1,{x:0,ease:Back.easeOut},"-=0.1");
			that.turtleTimeline.play();

			that.props.callback();
			TweenMax.to(that.threeEl,1,{opacity:1});
		});

		/* END MAIN SCENE */

		this.clock = new THREE.Clock();

		this.loop();
		this.resize();
		window.addEventListener("resize",this.resize.bind(this));
		window.addEventListener("mousemove",this.onMouseMove.bind(this));
	}

	onSlider(value){
		var that = this;

		if(value > 0.002 && !this.introHidden){
			this.introHidden = true;
			TweenMax.to(this.rendererIntro.domElement,0.3,{opacity:0});
			TweenMax.to(this.threeGradient,0.3,{opacity:1});
			TweenMax.to([document.body,document.querySelector("#impact-calculator")],0.3,{backgroundColor:"rgba(82,187,234,1)"});
			this.threeEl.classList.add("blue");
			document.querySelector("#impact-calculator").classList.add("stage3");
		}

		if(value <= 0.002 && this.introHidden){
			this.introHidden = false;
			TweenMax.to(this.rendererIntro.domElement,0.3,{opacity:1});
			TweenMax.to(this.threeGradient,0.3,{opacity:0});
			TweenMax.to([document.body,document.querySelector("#impact-calculator")],0.3,{backgroundColor:"#E0D6B0"});
			this.threeEl.classList.remove("blue");
			document.querySelector("#impact-calculator").classList.remove("stage3");
		}

		if(value > 0.37 && !this.particlesOn && window.innerWidth >750){
			this.particlesOn = true;
			TweenMax.to(that.particlesLeft.material.uniforms["mainOpacity"],0.5,{value:1});
		}

		if(value <= 0.37 && this.particlesOn && window.innerWidth >750){
			this.particlesOn = false;
			TweenMax.to(that.particlesLeft.material.uniforms["mainOpacity"],0.5,{value:0});
		}

		this.elements.forEach(function(el){
			if(value > el.threshold && el.isShown == false){
				el.isShown = true;
				TweenMax.to(el.scale,0.45,{x:1,y:1,z:1,ease:Back.easeOut});
			}

			if(value < el.threshold && el.isShown == true){
				el.isShown = false;
				TweenMax.to(el.scale,0.2,{x:0.0001,y:0.0001,z:0.0001,ease:Back.easeIn});
			}
		});
	}

	resize(){
		var width = window.innerWidth;
		if(width > 1700){
			width = 1700;
		}

		if(window.innerWidth < 750){
			this.canvasHeight = 600;
		}
		else{
			this.canvasHeight = 1100;
		}

		this.camera.aspect = width / (this.canvasHeight);
		this.camera.updateProjectionMatrix();

		this.renderer.setSize( width, (this.canvasHeight) );
		this.rendererIntro.setSize( width, (this.canvasHeight) );

		this.renderer.domElement.style.marginLeft = (-width/2)+"px";
		this.rendererIntro.domElement.style.marginLeft = (-width/2)+"px";
	}

	onMouseMove(e){
		this.mX = e.clientX - window.innerWidth/2;
		this.mY = e.clientY - window.innerHeight/2;
	}

	checkResponsive(){
		if(this.containerRight){
			this.containerRight.position.x = this.mapNum(window.innerWidth,750,1200,-380,0);
			this.containerLeft.position.x = this.mapNum(window.innerWidth,750,1200,600,0);
			this.containerLeftFront.scale.x = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerLeftFront.scale.y = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerLeftFront.scale.z = this.mapNum(window.innerWidth,750,1200,0.75,1);

			this.containerSnakeTree.scale.x = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerSnakeTree.scale.y = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerSnakeTree.scale.z = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerSnakeTree.position.x = this.mapNum(window.innerWidth,750,1200,this.containerSnakeTree.orX-330,this.containerSnakeTree.orX);
			this.containerSnakeTree.position.y = this.mapNum(window.innerWidth,750,1200,this.containerSnakeTree.orY+220,this.containerSnakeTree.orY);

			this.containerPalmTree.scale.x = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerPalmTree.scale.y = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerPalmTree.scale.z = this.mapNum(window.innerWidth,750,1200,0.75,1);
			this.containerPalmTree.position.x = this.mapNum(window.innerWidth,750,1200,this.containerPalmTree.orX-500,this.containerPalmTree.orX);
			this.containerPalmTree.position.y = this.mapNum(window.innerWidth,750,1200,this.containerPalmTree.orY+450,this.containerPalmTree.orY);

			this.turtle.position.x = this.mapNum(window.innerWidth,750,1200,this.turtle.orX-200,this.turtle.orX);

			this.circle.position.x = this.mapNum(window.innerWidth,750,1200,this.circle.orX-700,this.circle.orX);	
			this.treeBack.position.x = this.mapNum(window.innerWidth,750,1200,this.treeBack.orX-700,this.treeBack.orX);			
		}
	}

	mapNum(num, in_min, in_max, out_min, out_max) {
		return this.clamp(((num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min),out_min,out_max);
	}

	clamp(a,b,c){
		var ret = a;
		if(b > c){
			if(a > b){
				ret = b;
			}

			if(a < c){
				ret = c;
			}
		}
		else{
			if(a < b){
				ret = b;
			}

			if(a > c){
				ret = c;
			}
		}
		return ret;
	}

	loop(){
		var that = this;
		requestAnimationFrame(this.loop.bind(this));

		if(window.pageYOffset < this.canvasHeight){

			this.camera.position.x += (this.mX*0.5 - this.camera.position.x)*0.1;
			this.camera.position.y += ((-this.mY*0.5+700) - this.camera.position.y)*0.1;

			this.camera.lookAt(this.camTarget);

			if(parseFloat(this.rendererIntro.domElement.style.opacity) != 1){
				this.renderer.render(this.scene,this.camera);
			}

			if(parseFloat(this.rendererIntro.domElement.style.opacity) != 0){
				this.rendererIntro.render(this.sceneIntro,this.camera);
			}

			if(this.toucan){
				this.toucan.children[1].scale.set(1,Math.sin(this.toucan.offset),1);
				this.toucan.children[0].rotation.z = Math.sin(this.toucan.offset*0.25)*0.1;
				this.toucan.offset += 0.1;
				this.toucan.position.x = 3000 - (this.toucan.offset*0.02)%1 * 6000;
				this.toucan.position.z = this.toucan.orZ + (100 - (this.toucan.offset*0.02)%1 * 200);
				this.toucan.position.y = this.toucan.orY + (200 - (this.toucan.offset*0.02)%1 * 200);
			}

			if(this.toucan2){
				this.toucan2.children[1].scale.set(1,Math.sin(this.toucan2.offset),1);
				this.toucan2.children[0].rotation.z = Math.sin(this.toucan2.offset*0.25)*0.1;
				this.toucan2.offset += 0.1;
				this.toucan2.position.x = 3000 - (this.toucan2.offset*0.02)%1 * 6000;
				this.toucan2.position.z = this.toucan2.orZ + (100 - (this.toucan2.offset*0.02)%1 * 200);
				this.toucan2.position.y = this.toucan2.orY + (200 - (this.toucan2.offset*0.02)%1 * 200);
			}

			if(this.waterfallMat){
				this.waterfallMat.uniforms["time"].value += 1000/60;
				this.bush1Mat.uniforms["time"].value += 1000/60;
				this.bush2Mat.uniforms["time"].value += 1000/60;
				this.tailsLeftMat.uniforms["time"].value += 1000/60;
				this.tailsRightMat.uniforms["time"].value += 1000/60;
				this.fishMat.uniforms["time"].value += 1000/60;
				this.fish2Mat.uniforms["time"].value += 1000/60;
				if(this.fish){
					this.fish.position.x = Math.sin(this.fish.offset)*420;
					this.fish.position.z = Math.cos(this.fish.offset)*420 + 200;
					this.fish.rotation.y = this.fish.offset-Math.PI;
					this.fish.offset += 0.01;
				}

				if(this.fish2){
					this.fish2.position.x = Math.sin(this.fish2.offset)*280;
					this.fish2.position.z = Math.cos(this.fish2.offset)*280 + 200;
					this.fish2.rotation.y = this.fish2.offset-Math.PI;
					this.fish2.offset += 0.012;
				}
			}

			if(this.bubbles){
				this.bubbles.forEach(function(bubble,i){
					bubble.currScale += bubble.speed;
					var s = bubble.currScale % 0.7;
					bubble.scale.set(s,s,s);
				});
			}

			if(this.particlesLeft){
				this.particlesLeft.material.uniforms["time"].value += 1/60;
			}

			this.palmLeafs.forEach(function(leaf){
				leaf.rotation.y = Math.sin(leaf.offset)*0.05;
				leaf.offset += leaf.speed*0.01;
			});


		}

		this.checkResponsive();

	}

	render() {
		return (
        	
        	<div className="three" ref={element => this.threeEl = element}>
        		<div className="gradient-left"></div>
        		<div className="gradient-right"></div>
        	</div>
        		
      	);
	}
}



export default ThreeWorld;
